/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Badoo - Знайомся, спілкуйся,\nзустрічайся",
      "Невірний номер телефона",
      "Get the app",
      "Увійти через Apple",
      "Увійти через Facebook",
      "Увійти через Google",
      "Увійти",
      "Зареєструватися",
      "Щоб продовжити, будь ласка, введи символи, показані в полі нижче.",
      "Продовжити",
      "Введи символи",
      "Перевірка безпеки",
      "Оновити",
      "Створи новий пароль, який ти зможеш легко запам‘ятати:",
      "Оновити",
      "Підтвердь пароль",
      "Пароль повинен містити принаймні {{num}} [[characters:num@3]]",
      "Пароль",
      "Створи новий пароль",
      "Badoo - The Blog",
      "Робота",
      "Чат",
      "Міста",
      "Налаштування cookie",
      "Copyright © 2006 – дотепер. Bumble. Всі права захищені.",
      "Apple та логотип Apple є торговельними марками Apple Inc.{{__EOL__}}Google Play є торговельною маркою компанії Google LLC.",
      "Завантаження",
      "Facebook",
      "Слідкуй за нами",
      "Допомога",
      "Instagram",
      "Мова",
      "LinkedIn",
      "Огляд",
      "Badoo є частиною Bumble Inc.",
      "Політика конфіденційності",
      "Safety Centre",
      "Мапа сайту",
      "Закон про сучасне рабство",
      "Умови користування",
      "Twitter",
      "Вкажи свою email-адресу або номер телефону, і ми надішлемо тобі інструкцію зі створення нового паролю.",
      "Отримати новий пароль",
      "Вкажи свій імейл або номер телефону",
      "Забутий пароль",
      "Фото наведені лише в ілюстративних цілях",
      "Get the app",
      "We’re excited to bring renewed support, helpful technology, and safer experiences to help foster relationships formed with greater confidence. This is all part of Badoo’s commitment to being the app that builds dating confidence.",
      "We’ll continue to pioneer dating technology to meet the needs of daters as identified in this report, starting with the release of ‘<b><a href=\"{{url}}\">Deception Detector™</a></b>’, a machine learning model that has demonstrated <b>99.5% precision</b> in combating spam, scam and fake accounts.",
      "We remain <b>committed</b> to the responsible use of Artificial Intelligence (A.I.), ensuring human intelligence comes first and A.I. capabilities don’t damage the <b>authenticity</b> of our community;",
      "We’ll no longer contribute to the creation of dating trends that fuel <b>negative perceptions</b> and <b>behaviours</b>;",
      "We’ll work to identify <b>bad behaviour</b> in dating so we can minimise its impact on our community’s well-being;",
      "We’ll only work with influencer talent who we think are <b>authentic</b> and <b>realistic</b> in how they present themselves online;",
      "Take me to Badoo",
      "Our Confidence Commitments:",
      "We’ve published this report for daters, dating communities, and online platforms—anyone—to be able to use the findings to help people have a kinder, more enjoyable experience with greater possibilities than ever before.",
      "At Badoo, we know there’s work to be done. Our teams have studied findings and are making changes so we can play our part. But there are also immediate commitments we’ve decided to make.",
      "At a pivotal moment when we believe human connection has never been more valuable, and people having confidence in how they can form connections has never been more important, we have created an <b>industry first Dating Confidence Report.</b>",
      "Download the report",
      "Badoo has always been a pioneer in dating, creating one of the first online dating platforms in the world and being the first to reach 100 million downloads.",
      "The report details behaviours, attitudes and influences that have negatively influenced dating, supported by expert guidance on how we can enjoy more of the best parts—and be better equipped to manage (or change) the parts we’d all rather avoid.",
      "Being intentional: relaxing, being present, and being themselves in their dating experiences—on and offline",
      "Being able to ignore what they see on social media, and focus on what works for them;",
      "Feeling they can trust that who they’re seeing or speaking to is for real;",
      "Feeling clear in their own intentions and trusting that their matches are being genuine, too;",
      "Reducing paranoia and hypervigilance about negative dating behaviour;",
      "The key ingredients for greater dating confidence are:",
      "We believe this is the dating world’s biggest barrier to its potential—and our commitment to breaking this barrier has begun. Every year, instead of focusing on dating trends, we’ll track our own progress in building dating confidence and continue to assess the challenges daters face across the industry.",
      "The findings will lead to annual Confidence Commitments and innovations in our product to help minimise dating experiences that damage people’s confidence. Ultimately this’ll help make online dating a kinder, <b><u><a href=\"{{url}}\">safer</a></u></b> and more valuable experience for those who want meaningful connections. Our commitments for 2024 are below.",
      "Read Confidence Commitments",
      "The report shows us in no uncertain terms that dating confidence is at an all-time low for many singles.",
      "Чекати на взаємну симпатію не потрібно.{{__EOL__}}{{__EOL__}}Одразу переходь до змістовних чатів без зайвих кроків. Зрештою, найцікавіше – це спілкування з твоїм новим співрозмовником.",
      "Хочеш спілкуватися?",
      "Реєструючись, ти погоджуєшся з нашими <a class=\"link\" href=\"{{terms_url}}\">Умовами користування</a>. Дізнайся, як ми використовуємо твої дані, в нашій <a class=\"link\" href=\"{{privacy_url}}\">Політиці конфіденційності</a>",
      "Допомагаємо тобі бути собою <br />та заводити приємні знайомства.",
      "Зустрічайся з упевненістю.",
      "Або",
      "Вже маєш акаунт?",
      "Реєструйся за email або номером телефону",
      "Отримуй від знайомств те, що очікуєш.{{__EOL__}}Без непорозумінь.",
      "Просто хочеш спілкуватися? Не проблема.{{__EOL__}}Шукаєш другу половинку? Чудово!{{__EOL__}}{{__EOL__}}Ти зможеш у будь-який момент змінити свої наміри.",
      "Хочу зустрічатися",
      "Планую мати стосунки",
      "Шукаю спілкування",
      "Знайди тих, хто шукає те саме, що й ти.",
      "{{name}}, {{age}}",
      "Твоя безпека є для нас головним пріоритетом.",
      "Розділ Safety Centre є інформаційною базою, яка містить корисні матеріали та поради щодо безпечних знайомств.",
      "Відвідай наш Safety Centre",
      "Безпека завжди<br/>понад усе.",
      "У мене з самого початку було відчуття, що все складеться...",
      "Спочатку у мене не було серйозних намірів…",
      "Одна з головних порад для всіх, хто використовує Badoo – залишатися собою...",
      "Історії успіху на Badoo",
      "Прочитай більше історій",
      "Рейтинг__CUT__{{num}}",
      "Apple App Store",
      "Нам можна довіряти. З 2006 року ми допомогли познайомитися багатьом мільйонам людей.",
      "{{num}}+ МЛН__CUT__завантажень",
      "{{num}}+ МЛН",
      "Магазин Google Play",
      "Ми знаємося на своєму ділі.",
      "Увійди через імейл або номер телефону",
      "Введи свій пароль",
      "Не пам‘ятаєш пароль?",
      "Зареєструватися",
      "Не маєш акаунту?",
      "Вхід",
      "Зареєструватися"
],

    // These are the common words found in the lexemes of the app
    common: {
      "characters": {
            "few": [
                  "символи",
                  "символів",
                  "символам",
                  "символи",
                  "символами",
                  "символах"
            ],
            "many": [
                  "символів",
                  "символів",
                  "символам",
                  "символів",
                  "символами",
                  "символах"
            ],
            "plural": [
                  "символу",
                  "символу",
                  "символу",
                  "символу",
                  "символу",
                  "символу"
            ],
            "singular": [
                  "символ",
                  "символу",
                  "символу",
                  "символ",
                  "символом",
                  "символі"
            ]
      },
      "day": {
            "few": [
                  "дні",
                  "днів",
                  "дням",
                  "дні",
                  "днями",
                  "днях"
            ],
            "many": [
                  "днів",
                  "днів",
                  "дням",
                  "днів",
                  "днями",
                  "днях"
            ],
            "plural": [
                  "дня",
                  "дня",
                  "дня",
                  "дня",
                  "дня",
                  "дня"
            ],
            "singular": [
                  "день",
                  "дня",
                  "дню",
                  "день",
                  "днем",
                  "дні"
            ]
      },
      "hour": {
            "few": [
                  "години",
                  "годин",
                  "годинам",
                  "години",
                  "годинами",
                  "годинах"
            ],
            "many": [
                  "годин",
                  "годин",
                  "годинам",
                  "годин",
                  "годинами",
                  "годинах"
            ],
            "plural": [
                  "години",
                  "години",
                  "години",
                  "години",
                  "години",
                  "години"
            ],
            "singular": [
                  "година",
                  "години",
                  "годині",
                  "годину",
                  "годиною",
                  "годині"
            ]
      },
      "minute": {
            "few": [
                  "хвилини",
                  "хвилин",
                  "хвилинам",
                  "хвилини",
                  "хвилинами",
                  "хвилинах"
            ],
            "many": [
                  "хвилин",
                  "хвилин",
                  "хвилинам",
                  "хвилин",
                  "хвилинами",
                  "хвилинах"
            ],
            "plural": [
                  "хвилини",
                  "хвилини",
                  "хвилини",
                  "хвилини",
                  "хвилини",
                  "хвилини"
            ],
            "singular": [
                  "хвилина",
                  "хвилини",
                  "хвилині",
                  "хвилину",
                  "хвилиною",
                  "хвилині"
            ]
      },
      "month": {
            "few": [
                  "місяці",
                  "місяців",
                  "місяцям",
                  "місяці",
                  "місяцями",
                  "місяцях"
            ],
            "many": [
                  "місяців",
                  "місяців",
                  "місяцям",
                  "місяців",
                  "місяцями",
                  "місяцях"
            ],
            "plural": [
                  "місяця",
                  "місяця",
                  "місяця",
                  "місяця",
                  "місяця",
                  "місяця"
            ],
            "singular": [
                  "місяць",
                  "місяця",
                  "місяцю",
                  "місяць",
                  "місяцем",
                  "місяці"
            ]
      },
      "second": {
            "few": [
                  "секунди",
                  "секунд",
                  "секундам",
                  "секунди",
                  "секундами",
                  "секундах"
            ],
            "many": [
                  "секунд",
                  "секунд",
                  "секундам",
                  "секунд",
                  "секундами",
                  "секундах"
            ],
            "plural": [
                  "секунди",
                  "секунди",
                  "секунди",
                  "секунди",
                  "секунди",
                  "секунди"
            ],
            "singular": [
                  "секунда",
                  "секунди",
                  "секунді",
                  "секунду",
                  "секундою",
                  "секунді"
            ]
      },
      "year": {
            "few": [
                  "роки",
                  "років",
                  "рокам",
                  "роки",
                  "роками",
                  "роках"
            ],
            "many": [
                  "років",
                  "років",
                  "рокам",
                  "років",
                  "роками",
                  "роках"
            ],
            "plural": [
                  "року",
                  "року",
                  "року",
                  "року",
                  "року",
                  "року"
            ],
            "singular": [
                  "рік",
                  "року",
                  "року",
                  "рік",
                  "роком",
                  "році"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
